<span class="title-container" [class.disabled]="disabled()">
  @switch (type()) {
    @default {
      <h1 class="title" [class.title-blurred]="blur()">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
      </h1>
    }
    @case ('sub') {
      <h2 class="title" [class.title-blurred]="blur()">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
      </h2>
    }
    @case ('minor') {
      <h3 class="title" [class.title-blurred]="blur()">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
      </h3>
    }
    @case ('tiny') {
      <h4 class="title" [class.title-blurred]="blur()">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
      </h4>
    }
  }
</span>

<ng-template #content>
  @if (text()) {
    {{ text() }}
  }
  @if (!text()) {
    <ng-container class="content"><ng-content></ng-content></ng-container>
  }
</ng-template>
